<template src="./components/templates/App.html" />

<script setup>

import {
    categoriesQuery,
    facetsQuery,
    locationsQuery,
    pageSettings,
    regionsQuery,
    routing,
    useCategories,
    useDottieInit,
    useFacets,
    useFacetsStore,
    useFetch,
    useLocationsStore,
    useParams,
    usePlaces,
    useQueryParamsStore,
    useRegionsStore,
    useResultsStore,
    useCategoriesStore,
} from '@timezoneone/dottie-client-jam';
import { config } from './config/config.js';

import Filters from './components/Filters.vue';
import ResultsHeader from './components/ResultsHeader.vue';
import Results from './components/Results.vue';
import Map from './components/Map.vue';
import Pagination from './components/Pagination.vue';

// Overrides
import { paginatedListingsQuery } from './graphql/paginatedListings.js';

/*
    Import all the functionality that we
    require from 'dottie-client-jam'
*/
const categoriesStore = useCategoriesStore();
const facetsStore = useFacetsStore();
const locationsStore = useLocationsStore();
const queryParams = useQueryParamsStore();
const regionsStore = useRegionsStore();
const resultsStore = useResultsStore();

/*
    Initialise DOTTIE functionality!

    NB: this is the place to override functionality
    from 'dottie-client-jam'. For example, you could
    import a custom version of the 'categoriesQuery'
    here and then send it to the 'useDottieInit()'
    function
*/
useDottieInit(
    categoriesQuery,
    categoriesStore,
    config,
    facetsQuery,
    facetsStore,
    locationsQuery,
    locationsStore,
    pageSettings,
    paginatedListingsQuery,
    queryParams,
    regionsQuery,
    regionsStore,
    resultsStore,
    routing,
    useCategories,
    useFacets,
    useFetch,
    useParams,
    usePlaces,
);

</script>
